import { render, staticRenderFns } from "./MySwiper.vue?vue&type=template&id=0c894a0c&scoped=true&"
import script from "./MySwiper.vue?vue&type=script&lang=js&"
export * from "./MySwiper.vue?vue&type=script&lang=js&"
import style0 from "./MySwiper.vue?vue&type=style&index=0&id=0c894a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c894a0c",
  null
  
)

export default component.exports